import type { Collection } from "@shopify/hydrogen-react/storefront-api-types";
import { useQuery } from "react-query";
import { Link, LoadingSpinner, RichText, UnexpectedError } from "atoms";
import { client } from "../api/client";

const getCollection = (handle: string) =>
  client.query<{ data: { collection: Collection } }>(`{
  collection(handle: "${handle}") {
    id
    title
    description
    descriptionHtml
    handle
    products(first: 4) {
      nodes {
        id
        title
        handle
      }
    }
  }
}`);

type CollectionDetailsProps = {
  handle: string;
};

function CollectionDetails({ handle }: CollectionDetailsProps) {
  const { data, error, isError } = useQuery(
    ["collections", "detail", handle],
    () => getCollection(handle),
    {
      select: (d) => d.data.collection,
    },
  );

  if (data) {
    return <ConnectedCollectionDetails {...data} />;
  }

  if (isError) {
    return <UnexpectedError error={error} />;
  }

  return <LoadingSpinner />;
}

function ConnectedCollectionDetails({
  title,
  handle,
  descriptionHtml,
  products,
}: Collection) {
  return (
    <div>
      <p>
        <Link to="/dev-shop">&larr; Collections</Link>
      </p>
      <br />

      <h2>{title}</h2>

      {descriptionHtml && <RichText value={descriptionHtml} />}

      {products && (
        <>
          <p>Products:</p>
          <ul>
            {products.nodes.map((p) => (
              <li key={p.id}>
                <Link
                  to={`/dev-shop/products/${p.handle}`}
                  state={{ title, handle }}
                >
                  {p.title}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export { CollectionDetails };
